import { Cell, flexRender } from '@tanstack/react-table';
import clsx from 'clsx';

import { DefaultType } from '@@/datatables/types';

interface Props<D extends DefaultType = DefaultType> {
  cells: Cell<D, unknown>[];
  className?: string;
  onClick?: () => void;
  isHighlighted?: boolean;
}

export function TableRow<D extends DefaultType = DefaultType>({
  cells,
  className,
  onClick,
  isHighlighted = false,
}: Props<D>) {
  return (
    <tr
      className={clsx(className, { 'cursor-pointer': !!onClick })}
      onClick={onClick}
    >
      {cells.map((cell, index) => (
        <td
          key={cell.id}
          className={clsx(cell.column.columnDef.meta?.className, 'h-20', {
            relative: isHighlighted && index === 0,
          })}
        >
          <div
            className={clsx('h-full', { 'pl-2': isHighlighted && index === 0 })}
          >
            {flexRender(cell.column.columnDef.cell, cell.getContext())}
          </div>
        </td>
      ))}
    </tr>
  );
}
